import React,{useEffect} from 'react'
import Poster from '../Poster/Poster'
import Deal from '../Deal/Deal'
import {useLocation } from 'react-router-dom'
import IB from '../IB/IB'
import DestinationOffer from '../DestinationOffer/DestinationOffer'
import WhyChoose from '../WhyChoose/WhyChoose'

const Home = () => {
  const location = useLocation(); 

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100); 
    }
  }, [location]);
  return (
    <>
        <Poster/>
        <Deal/>
        <IB/>
        <DestinationOffer/>
        <WhyChoose/>
    </>
  )
}

export default Home